import { DefaultDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/default-dataset-size-limiter";
import { getUserUniqueConvertDatasetSizeLimit } from "@/actions/db/user-unique-dataset-limits";

export class ConvertDatasetSizeLimiter extends DefaultDatasetSizeLimiter {
  async getUniqueLimit(userId: string): Promise<number | null> {
    return await getUserUniqueConvertDatasetSizeLimit(userId);
  }
}
